import Ratio from './Ratio';

export * from './Ratio';

export default Ratio;
